// Company Component

import { Component, ViewChild } from '@angular/core';
import { Message, SelectItem, ConfirmationService, ConfirmEventType } from 'primeng/api';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { link, breadcrumb, stat } from '../../layout/header/header.component';
import { MultiSelectQuestion } from 'src/app/misc/component/dynamic-form/question-multiselect';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss']
})
export class CompanyComponent {
  skelition = true;

  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;

  messages: Message[] = [];
  translator: TranslatorPipe = new TranslatorPipe()

  header = this.translate('External Company');
  links: link[] = [
    {
      name: this.translate('Register External Coordinator'),
      icon: 'pi pi-user-plus',
      link: '/add-external-coordinator',
      visible: true
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('External Company'), link: '/company' },
  ];

  stats: stat[] = [];

  companyData: any[] = [];
  coordinators: any[] = [];
  allCoordinators : any[] = [];

  data: any[] = [];
  iconOptions: SelectItem[] = [];
  questions: QuestionBase<string>[] = [];

  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;

  fixedTrainingItemsIds: string[] = [
    '64ecbe4ff6c283d49c8f3d61',
    '64edba9b9b8555d3669790dc',
    '654e867bb9f4c5b8996191c5',
  ];
  fixedTrainingItems: any[] = [];

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService
  ) { }

  ngOnInit() {

    Promise.all([this.getCompanyData(),this.fetchCoordinators(), this.getOuType(), this.fetchAllCoordinators()]).then(() => {
      this.makequestion();
    });
  }



  getOuType = async () => {
    try {
      const res = await this.dataService.postData('training-type/get/?offset=1000&page=1', {});
      if (res.error) {
        console.error('Error fetching data:', res.error);
        return;
      }
      if (res.data) {
        for (const item of res.data) {
          if (!this.fixedTrainingItemsIds.includes(item._id)) {
            this.fixedTrainingItems = this.fixedTrainingItems.concat([{
              name: item.arabic,
              icon: item.icon,
              value : item._id
            }]);
          }
        }
       
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };



  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  private async fetchCoordinators(): Promise<void> {
    let res = await this.dataService.postData('user/get', {
      'externalUser.status': true,
      'externalUser.role': 'Coordinator',
      'externalUser.company': '6637b2662ba03d1ffddfd2b6',
    });
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.coordinators = res.data.map((item: any) => {
      return {
        _id: item._id,
        label: `${item.name.first} ${item.name.middle} ${item.name.last}`,
        value: item._id,
      };
    });

    
  }

  private async fetchAllCoordinators(): Promise<void> {
    let res = await this.dataService.postData('user/get', {
      'externalUser.status': true,
      'externalUser.role': 'Coordinator',
    });
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.allCoordinators = res.data.map((item: any) => {
      return {
        _id: item._id,
        label: `${item.name.first} ${item.name.middle} ${item.name.last}`,
        value: item._id,
      };
    });
  }



  

  getCompanyData = async () => {
    try {
      let res = await this.dataService.getData('company/');


      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }



      

      res.data.forEach((item:any)=>{
        item.allowed_trainings = item.allowed_trainings.map((e:any)=>{
          return {name: e.arabic,
          icon: e.icon,
          value : e._id}
        })  
      })

     
      
      this.companyData = res.data.filter((e:any)=> e._id != '6637b2662ba03d1ffddfd2b6');
      this.companyData.forEach((item: any) => {
        this.data.push({
          '#': { n: item._id, i: 'pi pi-angle-left' },
          'الاسم': { n: item.name },
          'الموقع الإلكتروني': { n: item.website, i: 'pi pi-globe' },
          'العنوان': { n: item.location },
          الحالة: {
            n: item.active,
            i: item.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
          },
          Action: [
            {
              n: 'Delete',
              i: 'pi pi-times',
              s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
            },
            {
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            },
          ],
        });
      });
      this.updateTypeCounts();
      this.skelition = false;
    } catch (error) {
      console.log(error);
    }
  };

  makequestion() {
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: this.translate('the name'),
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new TextboxQuestion({
        key: 'location',
        label: this.translate('The address'),
        required: true,
        
        filter: true,
        order: 2,
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new TextboxQuestion({
        key: 'website',
        label: this.translate('website'),
        required: true,
        
        filter: true,
        order: 3,
        className: 'col-md-12 col-sm-12 col-12',
      }),
      new DropdownQuestion({
        key: 'coordinator',
        label: this.translate('coordinator'),
        required: true,
        options: this.coordinators,
        filter: true,
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new MultiSelectQuestion({
        key: 'allowed_trainings',
        label: this.translate('allowed_trainings'),
        required: true,
        options: this.fixedTrainingItems,
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'active',
        label:  this.translate('the condition'),
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        order: 5,
        className: 'col-md-12 col-sm-12 col-12',
        value: true,
        visibility: 'false',
      }),
    ];
  }

  receiveData = async ($event: any) => {
    try {
      let data = $event;

      
      data.allowed_trainings = data.allowed_trainings.map((obj: any) => obj.value);
      let res = await this.dataService.postData('company/', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.DynamicFormComponent.resetForm();
      let updatedData = res.data;

      this.companyData.push(updatedData);
      this.data.unshift({
        '#': { n: res.data._id, i: 'pi pi-angle-left' },
        'الاسم': { n: res.data.name },
        'الموقع الإلكتروني': { n: res.data.website, i: 'pi pi-globe' },
        'العنوان': { n: res.data.location },
        الحالة: {
          n: data.active,
          i: data.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
        },
        Action: [
          {
            n: 'Delete',
            i: 'pi pi-times',
            s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
          },
          {
            n: 'Update',
            i: 'pi pi-file-edit',
            s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
          },
        ],
      });
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  UpdateData = async ($event: any) => {
    try {
      let data: any = $event;
      data.allowed_trainings = data.allowed_trainings.map((obj: any) => obj.value);
      data
      
      data._id = this.updateData._id;
      let res = await this.dataService.postData(
        'company/',
        data,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.updateModal = false;
      this.updateData = undefined;

      console.log("data===>",data);
     
      // updating in table
      const myObject = this.data.find((item) => item['#'].n === data._id);
      if (myObject) {
        (myObject['الاسم'].n = data.name),
          (myObject['الاسم'].i = data.icon);
        myObject['الحالة'].n = data.active;
        myObject['العنوان'].n = data.location;
        myObject['الحالة'].i = data.active
          ? 'pi pi-check-circle'
          : 'pi pi-check-circle';
        myObject['الموقع الإلكتروني'].n = data.website;
      }

      this.data.map((e, i) => {
        if (e['#'].n === data._id) {
          this.data[i] = myObject;
          return;
        }
      });

      this.companyData.map((e, i) => {
        if (e._id === data._id) {
          this.companyData[i] = data;
          return;
        }
      });
      console.log(this.companyData);
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };


  updateCoordinators : any

  actionCall($event: any) {
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deleteCatagory($event.id),
        });
        break;
      case 'Update':
        this.updateData = this.companyData.find((item) => item._id == $event.id);

        this.updateCoordinators = []

        this.updateCoordinators = cloneDeep(this.coordinators)

        this.updateCoordinators.push(this.allCoordinators.find((e:any)=> e._id == this.updateData.coordinator))

        



        this.updateQuestions = [


          new TextboxQuestion({
            key: 'name',
            label: this.translate('the name'),
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.name,
            className: 'col-12',
          }),

          new TextboxQuestion({
            key: 'location',
            label: this.translate('The address'),
            required: true,
            options: this.coordinators,
            filter: true,
            value: this.updateData.location,
            order: 2,
            className: 'col-12',
          }),

          new TextboxQuestion({
            key: 'website',
            label: this.translate('website'),
            required: true,
            options: this.coordinators,
            filter: true,
            order: 3,
            value: this.updateData.website,
            className: 'col-12',
          }),

          new DropdownQuestion({
            key: 'coordinator',
            label: this.translate('coordinator'),
            required: true,
            options: this.updateCoordinators,
            value : this.updateData.coordinator,
            filter: true,
            order: 4,
            className: 'col-md-12 col-sm-12 col-12',
          }),

          new MultiSelectQuestion({
            key: 'allowed_trainings',
            label: 'allowed_trainings',
            required: true,
            options: this.fixedTrainingItems,
            value : this.updateData.allowed_trainings,
            order: 5,
            className: 'col-md-12 col-sm-12 col-12',
          }),

          new DropdownQuestion({
            key: 'active',
            label: this.translate('the condition'),
            required: true,
            value: this.updateData?.active,
            options: [
              { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
              { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
            ],
            order: 5,
            className: 'col-12',
          }),
        ];
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }

  deleteCatagory = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`data-fields/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.data = this.data.filter((item) => item['#'].n !== id);
      this.companyData = this.companyData.filter((item) => item._id !== id);
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: this.translate('Yes'),
      rejectLabel: this.translate('no'),
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  private updateTypeCounts(): void {
    let activeCount = this.companyData.filter((e) => e.active === true).length;
    let inactiveCount = this.companyData.length - activeCount;
    this.stats = [
      { name: this.translate('active'), number: activeCount, icon: 'pi pi-check-circle' },
      { name: this.translate('Inactive'), number: inactiveCount, icon: 'pi pi-times-circle' },
    ];
  }
}
